"use client";

import { createContext, useMemo } from "react";
import { NextIntlClientProvider } from "next-intl";
import { ReactQueryClientProvider } from "@/lib/query-client-provider";
import { useLanguageChange } from "@/hooks/useLanguageChange";

export const LanguageContext = createContext<{
  switchLanguage: (locale: string) => void;
}>({ switchLanguage: () => {} });

export function Providers({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const { locale, messages, switchLanguage } = useLanguageChange();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const contextValue = useMemo(() => ({ switchLanguage }), [switchLanguage]);

  return (
    <LanguageContext.Provider value={contextValue}>
      <NextIntlClientProvider
        timeZone={timeZone}
        messages={messages}
        locale={locale}
      >
        <ReactQueryClientProvider>
          {children}
        </ReactQueryClientProvider>
      </NextIntlClientProvider>
    </LanguageContext.Provider>
  );
}
